import { render, staticRenderFns } from "./Lihat.vue?vue&type=template&id=580ef061"
import script from "./Lihat.vue?vue&type=script&lang=js"
export * from "./Lihat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports